import { MapToContext } from '@utils/objectWithDefault'

export class DestinationCountry {
  constructor (destinationCountryData) {
    const defaultDestinationCountry = {
      name: { val: '', type: String },
      id: { val: 0, type: Number },
      isoCode: { val: '', type: String }
    }

    MapToContext(this, defaultDestinationCountry, destinationCountryData)
  }
}

export default class DestinationCountries {
  constructor (destinationCountriesData) {
    const defaultDestinationCountries = {
      countries: { val: [], type: Array, subType: DestinationCountry }
    }

    if (destinationCountriesData != null && destinationCountriesData.countries != null) {
      destinationCountriesData.countries = destinationCountriesData.countries.sort((a, b) => a.name > b.name ? 1 : -1)
    }

    MapToContext(this, defaultDestinationCountries, destinationCountriesData)
  }

  getCountries () {
    return this.countries
  }
}
